export default __webpack_public_path__ + "static/media/cafe.03a2063d.svg";